import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          TabPane,
          FormControl,
          Table,
          Modal,
          ControlLabel,
          Label,
          OverlayTrigger,
          Tooltip,
          Glyphicon,
          Image,} from "react-bootstrap";
import {ToastContainer, ToastStore} from 'react-toasts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Document, Page } from 'react-pdf';
//import { Page, Text, View, Document, StyleSheet, PDFViewer } from '@react-pdf/renderer';
import Datetime from 'react-datetime';
import FormBuilderPage from '../formbuilder';
import { pdfjs } from 'react-pdf';
import FormdataService from "../../services/formdata-service";
import UsersService from "../../services/users-service";
import FormsService from "../../services/forms-service";
import EmailService from "../../services/email-service";
import UtilsService from "../../services/utils-service";


import ArchonFormBuilder from "../../components/archon-form-builder";
import EventWidget from "../../components/widgets/event-widget";

import GLOBALS from '../../utils/Constants';
import _ from 'underscore';
import $ from 'jquery';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import './style.css';

//Props:
//clients
class Forms extends Component {

  constructor(props, context) {
      super(props, context);
      var forms = [
          {form_id: "1", form_name: "Post Incident Report", client: "Dio", date_added: "Dec. 3, 2018 @ 8:00 PM", branch: "Indianapolis", facility: "Lucas Oil"},
          {form_id: "2", form_name: "Daily Activity Summary Report", client: "Gabe Newell", date_added: "Dec. 3, 2018 @ 8:00 PM", branch: "West Lafayette", facility: "Purdue Stadium"},
          {form_id: "3", form_name: "Annual Report", client: "Roboutte Guilliman", date_added: "Dec. 3, 2018 @ 8:00 PM", branch: "Washington D.C.", facility: "ALL"},
      ]

      var formArchives = [
          {form_id: "1",
            form_name: "Post Incident Report",
            type: "Jump Start",
            client: "Dio",
            date_added: "Dec. 3, 2018 @ 8:00 PM",
            branch: "Indianapolis",
            facility: "Lucas Oil",
            status: "Incomplete"},
          {form_id: "2",
            form_name: "Daily Activity Summary Report",
            type: "D.A.R.",
            client: "Gabe Newell",
            date_added: "Dec. 3, 2018 @ 8:00 PM",
            branch: "West Lafayette",
            facility: "Purdue Stadium",
            status: "Complete"},
          {form_id: "3",
            form_name: "Annual Report",
            type: "D.A.R.",
            client: "Roboutte Guilliman",
            date_added: "Dec. 3, 2018 @ 8:00 PM",
            branch: "Washington D.C.",
            facility: "ALL",
            status: "Complete"},
      ];

      const storedCredentials = UsersService.sharedInstance.getStoredCredentials();

      this.state = {
          show: false,
          clients: [],
          forms: forms,
          formsToEdit: [], //Every Form clicked in Start Form, this is populated.
          formArchives: formArchives,
          file: null,
          showFormInputModal: false,
          guiltyObject: null,//Generic
          confirmationModalType: null,
          showConfirmationModal: false,
          tabActiveIndex: 1,
          showEditTab: false,
          showNewTab: false,
          showPDFTab: false,
          imagesToUpload:[],
          storedCredentials: storedCredentials,
          sortFilters: {activeFilter: "fileName", fileName: "descending", client: "ascending"},
          newForm: {form_name: "", occurrenceCount: 0, occurrences: [{occurrenceDate: "", occurrenceDetails: ""}]},//Will contain new attributes depnding on the chosen form.
      }

      this.getAllFormsByLicense = this.getAllFormsByLicense.bind(this);
      this.submitNewForm = this.submitNewForm.bind(this);
      this.submitEditForm = this.submitEditForm.bind(this);

      this.setActiveTabIndex = this.setActiveTabIndex.bind(this);
      this.convertCanvasToPDF = this.convertCanvasToPDF.bind(this);
      this.sendEmail = this.sendEmail.bind(this);
      this.findClientToDisplay = this.findClientToDisplay.bind(this);
  }

  componentWillMount(){
      pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;//PDF Worker, used by pdf
      this.getAllFormsByLicense();
      this.getFormDataByType("Client");
      this.getSubmittedFormsByLicense();
  }

  getAllFormsByLicense(){
      const storedCredentials = this.state.storedCredentials;
      const loginResponse = storedCredentials.loginResponse;

      var params = {
        "license":loginResponse.data[0].User_License,
        "auth_username":loginResponse.data[0].User_ID,
        "token":loginResponse.token_data.token,
      };

      UsersService.sharedInstance.getAllFormsByLicense(params)
      .then((response)=>{

          response.map((form, index)=>{
            form["client"] = "Client_"+index;
            form["branch"] = "Branch_"+index;
          });
          response = _.sortBy(response, "form_name");

          this.setState({
              forms: response
          });
      }).catch((error)=>{
          console.log(error);
      });
  }

  render() {
    var storedCredentials = this.state.storedCredentials;
    return (  <div>
                <Row className="widget-top-container">
                  <Col md={5} style={{backgroundColor: "white"}}>
                    <EventWidget events={this.props.events}/>
                  </Col>
                </Row>
                <Row className="main-settings-content">
                    <Col>
                        <div className="settings-header">
                            <h2>Forms</h2>
                        </div>
                        <div className="tab-container" >
                          <Tabs defaultActiveKey={1} activeKey={this.state.tabActiveIndex} id="forms-tabs"
                              onSelect={(key)=>{
                                            var newState = {tabActiveIndex: key};

                                            // if(key != 3) {
                                            //   newState["showEditTab"] = false;
                                            // }
                                            //
                                            // if(key != 5) {
                                            //   newState["showNewTab"] = false;
                                            // }
                                            //
                                            // if(key != 6) {
                                            //   newState["showPDFTab"] = false;
                                            // }

                                            this.setState(newState);

                                            }}>
                              <Tab eventKey={1} title="Start Form" className="forms-tab">
                                  {this.renderStartForm()}
                              </Tab>
                              <Tab eventKey={2} title="Archives" className="forms-tab" >
                                  {this.renderArchives()}
                              </Tab>
                              {
                                // storedCredentials.license == 'WILSON' || (storedCredentials.license == "CH99999A" && storedCredentials.username == 'ena')
                                // ? <Tab eventKey={3} title="Form Builder">
                                //     <FormBuilderPage />
                                //   </Tab>
                                // : null
                              }
                              {this.state.showEditTab
                                ? <Tab eventKey={3}
                                    className="forms-tab"
                                    title={<div>{"Edit "+this.state.guiltyObject.form_name}
                                      <Glyphicon glyph="remove" className="pull-right"
                                                                            style={{cursor: "pointer", marginLeft: 15}}
                                                                            onClick={(e)=>{
                                                                                e.stopPropagation();
                                                                                this.setState({
                                                                                  showEditTab: false,
                                                                                  tabActiveIndex: this.state.tabActiveIndex == 3 ? this.state.tabActiveIndex - 1 : this.state.tabActiveIndex,
                                                                                })
                                                                            }}/>
                                    </div>}>
                                    {this.renderEditFormArchive("fillUpdate")}
                                  </Tab>
                                : null}

                              {this.state.formsToEdit.map((formToEdit, i)=>{
                                var eventKey = 2 + (this.state.guiltyObject != null ? 1 : 0 ) + i + 1;
                                return <Tab eventKey={eventKey}
                                            className="forms-tab"
                                            title={<div>{"New \"" + formToEdit.form_name + "\""}
                                              <Glyphicon glyph="remove" className="pull-right"
                                                                                    style={{cursor: "pointer", marginLeft: 15}}
                                                                                    onClick={(e)=>{
                                                                                        e.stopPropagation();
                                                                                      this.closeFormToEdit(i);
                                                                                    }}/>
                                            </div>}>
                                        {this.renderStartFormNewForm(formToEdit)}
                                      </Tab>
                              })}

                          </Tabs>
                          {this.renderFormInputModal()}
                      </div>
                      </Col>
                  </Row>

                  {this.renderPreviewModal()}
                  <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
                  {this.renderConfirmationModal()}
              </div>
              );
  }

  componentDidMount() {
    if(this.props.redirectState != null) {
      var newState = {};
      newState = this.props.redirectState;
      this.setState(newState);
    }
  }

  renderStartForm() {

    var rows = [];

    this.state.forms.map((form, i)=>{
      rows.push (<tr key={i}
                      onClick={()=>{
                        var newFormsToEdit = this.state.formsToEdit.slice();
                          newFormsToEdit.push(form);
                          this.setState({
                            formsToEdit: newFormsToEdit.slice(),
                            tabActiveIndex: 2 + (this.state.guiltyObject != null ? 1 : 0 )+ (newFormsToEdit.length),
                          })
                        }}>
                  <td style={{textDecorationLine: 'none', cursor: "pointer", textAlign: "left"}}>
                          <OverlayTrigger
                            placement="top"
                            delay={200}
                            overlay={<Tooltip id="overlay-example">
                                        Create new {form.form_name}
                                      </Tooltip>}>
                                      <div>{form.form_name}</div>
                                      </OverlayTrigger></td>
                  <td>{form.client_name}</td>
                  <td>{form.branch_name}</td>
              </tr>);
    });

    return (<div style={{padding: 20}}><Table striped bordered hover >
              <thead>
                <tr>
                  <th> Form Title
                        <Glyphicon glyph={this.state.sortFilters.fileName == "ascending" ? "arrow-up" : "arrow-down"}
                                onClick={()=>{
                                          var newSortFilters = JSON.parse(JSON.stringify(this.state.sortFilters));
                                          newSortFilters.activeFilter = "fileName";
                                          newSortFilters.fileName = newSortFilters.fileName == "ascending" ? "descending" : "ascending";
                                          this.setState({sortFilters: newSortFilters, forms: this.sortForms(newSortFilters.activeFilter, newSortFilters.fileName)});
                                        }}
                            style={{marginRight: 15, cursor: "pointer"}}/></th>
                  <th style={{textAlign: "center"}}>Client
                        <Glyphicon glyph={this.state.sortFilters.fileName == "ascending" ? "arrow-up" : "arrow-down"}
                                onClick={()=>{
                                          var newSortFilters = JSON.parse(JSON.stringify(this.state.sortFilters));
                                          newSortFilters.activeFilter = "client";
                                          newSortFilters.fileName = newSortFilters.fileName == "ascending" ? "descending" : "ascending";
                                          this.setState({sortFilters: newSortFilters, forms: this.sortForms(newSortFilters.activeFilter, newSortFilters.fileName)});
                                        }}
                            style={{marginRight: 15, cursor: "pointer"}}/></th>
                  <th style={{textAlign: "center"}}>Branch</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0
                  ? rows
                  : <tr>
                      <td colSpan="3" style={{textAlign: "center"}}>No Forms</td>
                    </tr  >}
              </tbody>
            </Table></div>);
  }

  renderArchives() {
    var rows = [];
    var clientToDisplay = null;

    const utils = UtilsService.sharedInstance;
    let formArchives  = utils.checkIfValidObjectOrArray(this.state.formArchives) ? this.state.formArchives : [];

    formArchives.map((formArchive, i)=>{
      if(formArchive.json_string != null) {
          clientToDisplay = this.findClientToDisplay(JSON.parse(formArchive.json_string));
      }

      var statusColor = formArchive.status == "Incomplete"
                    ? "orange"
                    : "green";
      rows.push (<tr key={i}>
                  <td style={{textDecorationLine: 'underline', cursor: "pointer", textAlign: "left"}}
                      onClick={()=>{
                        this.openPDFFor(formArchive);
                      }}><OverlayTrigger
                          placement="top"
                          delay={200}
                          overlay={<Tooltip id="overlay-example">
                                      Open PDF in new tab
                                    </Tooltip>}>
                                      <div>{formArchive.form_name}</div>
                                    </OverlayTrigger>
                            </td>
                  <td>{formArchive.type}</td>
                  <td>{formArchive.date_added}</td>
                  <td>{clientToDisplay !== "No Client Set" ? this.getNameForRecno(clientToDisplay, "Client", this.state.clients) :   clientToDisplay }</td>
                  <td style={{color: statusColor}}>{formArchive.status}</td>

                </tr>);
    });

    return (<div style={{padding: 20}}><Table striped bordered hover >
              <thead>
                <tr>
                  <th>Form Title</th>
                  <th style={{textAlign: "center"}}>Form Type</th>
                  <th style={{textAlign: "center"}}>Date Added</th>
                  <th style={{textAlign: "center"}}>Client</th>
                  <th style={{textAlign: "center"}}>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0
                  ? rows
                  : <tr>
                      <td colSpan="6">No Form Archives</td>
                    </tr  >}
              </tbody>
            </Table></div>);
  }

  renderEditFormArchive(mode) {
    return <ArchonFormBuilder mode={mode}
                              onSave={this.submitEditForm}
                              forms={this.state.forms}
                              clients={this.state.clients}
                              formToEdit={this.state.guiltyObject}
                              imagesToUpload={this.state.guiltyObject.attachments_data}
                              />
    // return (<div style={{padding: 20, alignSelf: 'center'}}>
    //           <h2>{this.state.guiltyObject.form_name}</h2>
    //           <div style={{paddingTop: 80, fontSize: 18}}>Input fields still under construction ¯\_(ツ)_/¯</div>
    //
    //           <div style={{width: "100%", marginTop: 80}}>
    //             <Button variant="primary" size="lg" onClick={()=>{this.submitEditForm()}}>
    //               Submit
    //             </Button>
    //           </div>
    //
    //         </div>);
  }

  renderStartFormNewForm(formToEdit) {
    var clients = this.state.clients;
    var hasClients = clients != null && clients.length > 0;
    // if(formToEdit.form_name.indexOf("Daily Activity") >= 0) {
    //   return (<div style={{padding: 20}}>
    //             <h2 style={{color: "#F45F21"}}>{formToEdit.form_name}</h2>
    //             <div style={{maxWidth: "100%", maxHeight: "30%", marginTop: 80, justifyContent: "center"}}>
    //
    //                   {
    //                     this.state.imagesToUpload.length > 0
    //                     ?   <Button variant="primary" size="lg">
    //                           <div style={{maxWidth: "30%", maxHeight: "30%"}}>
    //                             <Image src={this.state.imagesToUpload[0]} fluid={"true"} rounded />
    //                           </div>
    //                         </Button>
    //                     : null
    //                   }
    //             </div>
    //             <div style={{width: "100%", marginTop: 80, alignItems: "center"}}>
    //             <Row>
    //                           <Col md={6}>
    //                               <FormGroup controlId="clientDropdown" className="row-md-12" style={{textAlign: "left"}}>
    //                                 <ControlLabel htmlFor="clientDropdown" className="control-label">Select Client</ControlLabel>
    //                                 <FormControl  componentClass="select" placeholder="Client"
    //                                               style={{width: "100%"}}
    //                                               defaultValue={"select"}
    //                                               value={this.state.newForm.client ? this.state.newForm.client : "select"}
    //                                               onChange={(e)=>{
    //                                                       var newNewForm = JSON.parse(JSON.stringify(this.state.newForm));
    //                                                       newNewForm["client"] = e.target.value;
    //                                                       this.setState({newForm: newNewForm});
    //                                                     }}>
    //                                     {hasClients
    //                                         ? clients.map((client, index) => {
    //                                             return <option key={index} value={client.name}>{client.name}</option>
    //                                           })
    //                                         : <option disabled value="select">No Clients</option>
    //                                     }
    //                                 </FormControl>
    //                               </FormGroup>
    //
    //                               <FormGroup controlId="detailTextArea" className="row-md-12 " style={{textAlign: "left"}}>
    //                                 <ControlLabel htmlFor="detailTextArea" className="control-label">Details</ControlLabel>
    //                                 <FormControl  componentClass="textarea" placeholder="Detail of Occurence"
    //                                               style={{width: "100%"}}
    //                                               value={this.state.newForm.details ? this.state.newForm.details : ""}
    //                                               onChange={(e)=>{var newNewForm = JSON.parse(JSON.stringify(this.state.newForm));
    //                                               newNewForm["details"] = e.target.value;
    //                                               this.setState({newForm: newNewForm});}} />
    //                               </FormGroup>
    //                           </Col>
    //                           <Col md={6}>
    //                               {this.renderInputs(formToEdit)}
    //                           </Col>
    //                         </Row>
    //
    //             <Button variant="primary" size="lg">
    //               <input style={{display: "hidden"}} ref={input => this.imageAttachment = input} id='selectImage' type="file"
    //                       onChange={(e)=>{console.log("selectImage: ", e);
    //                         this.setState({
    //                             imagesToUpload: [URL.createObjectURL(e.target.files[0])]
    //                           })}} />
    //             </Button>
    //             </div>
    //
    //               <div style={{width: "100%", marginTop: 80, alignItems: "center"}}>
    //                 <Button variant="primary" size="lg" onClick={()=>{this.submitNewForm(JSON.stringify(this.state.newForm))}}>
    //                   Submit
    //                 </Button>
    //               </div>
    //           </div>);
    //
    // } else {
      return <ArchonFormBuilder mode={"fill"}
                                onSave={this.convertCanvasToPDF}
                                forms={this.state.forms}
                                clients={clients}
                                formToEdit={formToEdit}/>
    //}

  }

  //Fill mode form builder
  renderArchiveFormBuilder() {
    return <ArchonFormBuilder mode={"readOnly"}
                              onSave={this.submitNewForm}
                              forms={this.state.forms}
                              clients={this.state.clients}
                              formToEdit={this.state.guiltyObject}/>
  }

  renderPDFTab() {
    //  file="https://s1.q4cdn.com/806093406/files/doc_downloads/test.pdf"
    //  file="https://cirrus.archonapps.com/Uploads/CH99999A/101482/02_08_2019%20-%20Test.pdf"
    return (<div style={{padding: 20, alignSelf: 'center'}}>
              <h2>{this.state.guiltyObject.form_name}</h2>
                <div style={{paddingTop: 10, fontSize: 18, minHeight: 600, backgroundColor: "gray", alignItems: "center", textAlign: "center"}}>
                {
                   <Document
                    file="https://s1.q4cdn.com/806093406/files/doc_downloads/test.pdf"
                    onLoadSuccess={()=>{}}
                    renderMode="svg">
                    <Page pageNumber={1} />
                  </Document>
                }
                {
                  // <PDFViewer width={595} height={842}>
                  //   {this.state.pdfForm}
                  // </PDFViewer>
                }

                </div>
            </div>);
  }

  renderPreviewModal() {

    //Modal doesnt disappear when pressing action buttons
    var formArchive = this.state.guiltyObject;
    if(this.state.guiltyObject != null) {
      return (<Modal
                show={this.state.showPDFTab}>
                <Modal.Header>
                    <b style={{fontSize: 20}}>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={<Tooltip id="overlay-example">
                                    Close
                                  </Tooltip>}>
                        <Glyphicon glyph="remove" className="pull-right"
                                                style={{cursor: "pointer", marginLeft: 10}}
                                                onClick={()=>{
                                                  this.setState({showPDFTab: false});
                                                }}/>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={<Tooltip id="overlay-example">
                                    Delete this item
                                  </Tooltip>}>
                     <Glyphicon glyph="trash"
                        className={"pull-right"}
                        onClick={()=>{
                                  this.setState({
                                    showConfirmationModal: true,
                                    confirmationModalType: "deleteFormArchive",
                                    guiltyObject: formArchive,
                                  })
                                }}
                        style={{ cursor: "pointer", marginLeft: 10}}/>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={<Tooltip id="overlay-example">
                                    Download this item
                                  </Tooltip>}>
                     <Glyphicon glyph="download-alt"
                        className={"pull-right"}
                        onClick={()=>{
                                  this.downloadFormArchive(formArchive);
                                }}
                        style={{ cursor: "pointer", marginLeft: 10}}/>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={<Tooltip id="overlay-example">
                                    Edit this item
                                  </Tooltip>}>
                     <Glyphicon glyph="pencil"
                        className={"pull-right"}
                        onClick={()=>{
                                  this.setState({showPDFTab: false});
                                  this.editFormArchive(formArchive);
                                }}
                        style={{ cursor: "pointer", marginLeft: 10}}/>
                    </OverlayTrigger>

                  </b>
                </Modal.Header>
                <Modal.Body>
                  {this.state.showPDFTab
                    ? this.renderEditFormArchive("readOnly")
                    : null}
                </Modal.Body>
              </Modal>);
    } else {
      return null
    }

  }

  renderWidgets(){
      return(
          <Row className="dispatch-comm">
              <Col className="" xs={4} md={4} >
                  <div className="card">
                      {/* <div className="card-header">
                              <FontAwesomeIcon className="card-header-icon" icon="phone"/>
                              <h5>DISPATCH</h5>
                      </div>

                      <div className="card-content">
                          <Button className="call-dispatch red-btn">CALL DISPATCH</Button>
                      </div> */}
                  </div>
              </Col>
              <Col className="content-section" xs={8} md={8}>
                  <div className="card">
                      {/* <div className="card-header">
                          <FontAwesomeIcon className="card-header-icon" icon="comment-alt"/><h5>COMM LOG</h5>
                      </div>
                      <div className="card-content">
                          <form>
                              <FormGroup controlId="formBasicText">
                              <FormControl
                                  type="text"
                                  placeholder="Enter text"
                              />
                              </FormGroup>
                          </form>
                          <Button className="comm-log-btn green-btn">ADD ENTRY</Button>
                      </div> */}
                  </div>
              </Col>
          </Row>
      )
  }

  renderFormInputModal() {
    var windowInnerWidth = window.innerWidth;
    var modalWidth = windowInnerWidth * 0.8;
    var paddingLeft = windowInnerWidth * 0.1;

    return (
        <Modal style={{marginTop: "10%"}} show={this.state.showFormInputModal} onHide={()=>{}}>
            <Modal.Body className="warning-body" style={{}}>
                <h1 className="warning-header">{this.state.guiltyObject ? this.state.guiltyObject.form_name : "No Form Selected"}</h1>
                  <div style={{paddingTop: 80, paddingBottom: 80, fontSize: 18}}>Input fields still under construction ¯\_(ツ)_/¯</div>
                <div className="modal-buttons">
                    <Button className="red-btn" onClick={()=>{this.setState({showFormInputModal: false, guiltyObject: null})}}>Exit & Discard</Button>
                    <Button className="green-btn" onClick={()=>{this.setState({showFormInputModal: false, guiltyObject: null})}}>Continue Editing</Button>
                </div>
            </Modal.Body>
         </Modal>
    );
  }

  renderConfirmationModal() {
    var guiltyObject = this.state.guiltyObject;
    switch(this.state.confirmationModalType) {
      case 'deleteFormArchive':
        return (<Modal style={{marginTop: "10%"}}
                        show={this.state.showConfirmationModal}
                        onExit={()=>{this.setState({showConfirmationModal: false, guiltyObject: null, confirmationModalType: null})}}>
                        <Modal.Header>
                          <b style={{fontSize: 20}}>Confirm Deletion</b>
                        </Modal.Header>
                        <Modal.Body>
                          Are you sure you want to delete "<b>{guiltyObject.form_name}</b>" from Archives?
                        </Modal.Body>
                        <Modal.Footer>
                          <Button onClick={()=>{this.setState({showConfirmationModal: false})}}>Cancel</Button>
                          <Button bsStyle="danger" onClick={()=>{
                            this.deleteFormArchive();
                          }}>Delete</Button>
                        </Modal.Footer>
                </Modal>);
      case 'deleteForm':
        return (<Modal style={{marginTop: "10%"}}
                        show={this.state.showConfirmationModal}
                        onExit={()=>{this.setState({showConfirmationModal: false, guiltyObject: null, confirmationModalType: null})}}>
                        <Modal.Header>
                          <b style={{fontSize: 20}}>Confirm Deletion</b>
                        </Modal.Header>
                        <Modal.Body>
                          Are you sure you want to delete "<b>{guiltyObject.form_name}</b>" from Forms?
                        </Modal.Body>
                        <Modal.Footer>
                          <Button onClick={()=>{this.setState({showConfirmationModal: false})}}>Cancel</Button>
                          <Button bsStyle="danger" onClick={()=>{
                            this.deleteForm();
                          }}>Delete</Button>
                        </Modal.Footer>
                </Modal>);
      default:
        return (<Modal style={{marginTop: "10%"}}
                      show={this.state.showConfirmationModal}
                      onExit={()=>{this.setState({showConfirmationModal: false})}}>
                      <Modal.Header>
                        <b style={{fontSize: 20}}>Confirm Deletion</b>
                      </Modal.Header>
                      <Modal.Body>
                        Invalid Modal Type: "{this.state.confirmationModalType}"
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={()=>{this.setState({showConfirmationModal: false})}}>Close</Button>
                      </Modal.Footer>
                </Modal>);
    }
  }

  deleteFormArchive() {


    var newFormArchives = this.state.formArchives.slice();
    var itemIndex = newFormArchives.indexOf(this.state.guiltyObject);
    //newFormArchives.splice(itemIndex, 1);//Replace with API call.

    // let params = {
    //      "license": "",
    //      "token": "",
    //      "auth_username": "",
    //      "id": "" //id of the submitted form
    // };

    const storedCredentials = this.state.storedCredentials;
    const loginResponse = storedCredentials.loginResponse;
    const sub_user_id = loginResponse.data[0].recno;
    var id = this.state.guiltyObject.id;

    var params = {
      "token":storedCredentials.token,
      "auth_username":loginResponse.data[0].User_ID,
      "license":storedCredentials.license,
      "id": id,
    };

    FormsService.sharedInstance.deleteSubmittedForm(params)
    .then((response)=>{
        if(response.success == 0){
            ToastStore.error(response.code_error);
        }
        else{
          ToastStore.success("Form Deleted");
          this.setState({
            guiltyObject: null,
            confirmationModalType: null,
            showConfirmationModal: false,
            showPDFTab: false,
          });
          this.getAllFormsByLicense();
          this.getFormDataByType("Client");
          this.getMySubmittedForms();
        }
    }).catch((error)=>{
        console.log(error);
        ToastStore.error("Error deleting form.");
    });



  }

  downloadFormArchive(formArchive) {

    var componentToConvert = document.getElementById('canvasWindow');//$("#canvasWindow");
    html2canvas(componentToConvert)
      .then((canvas)=>{
        const imgData = canvas.toDataURL('image/png');
         const pdf = new jsPDF();
         pdf.addImage(imgData, 'JPEG', 0, 0);
         // pdf.output('dataurlnewwindow');
         pdf.save(formArchive.form_name+".pdf");

      })
      .catch((e)=>{
        console.log("canvas error: ", e);
      })
  }

  convertCanvasToPDF(json_string, files){
      var componentToConvert = document.getElementById('canvasWindow');//$("#canvasWindow");

      html2canvas(componentToConvert)
      .then((canvas)=>{
         // var image = canvas.toDataURL("image/jpeg")
         // var pdf=new jsPDF("p", "mm", "a4");
         // var width = pdf.internal.pageSize.getWidth();
         // var height = pdf.internal.pageSize.getHeight();
         // height = ratio * width;
         // pdf.addImage(image, 'JPEG', 0, 0,width-20, height-10);
         // let finalPDF = pdf.output('blob');
         // this.handleSubmitIncident(finalPDF);
          var wid = canvas.width;
          var hgt = canvas.height;
          var img = canvas.toDataURL("image/png", wid, hgt);
          var hratio = hgt/wid
          var pdf = new jsPDF('p','pt','a4');
          var width = pdf.internal.pageSize.width;
          var height = width * hratio
          pdf.addImage(img,'JPEG',20,20, width, height);
          let finalPDF = pdf.output('blob');
          this.submitNewForm(json_string, files, finalPDF);
      })
      .catch((e)=>{
        return e;
        console.log("canvas error: ", e);
      })
  }

  editFormArchive(formArchive) {
    this.setState({
      showEditTab: true,
      guiltyObject: formArchive,
      tabActiveIndex: 3,
    })
  }

  openPDFFor(formArchive) {

    this.setState({
      guiltyObject: formArchive,
      showPDFTab: true,
      pdfForm: this.createPDFForForm(JSON.parse(formArchive.json_string)),
    })

  }

  submitEditForm(json_string, files) {
    const storedCredentials = this.state.storedCredentials;
    const loginResponse = storedCredentials.loginResponse;

     var params = {
      "license":loginResponse.data[0].User_License,
      "auth_username":loginResponse.data[0].User_ID,
      "token":loginResponse.token_data.token,
      "id": this.state.guiltyObject.id,
      "json_string": json_string,
      "update_attachments_flag": 1, //set this if files where changed for now, ill set this to 1, to alwasy assumme that there are file changes,
      "files":files
    };
    FormsService.sharedInstance.updateSubmittedCustomForm(params)
    .then((response)=>{
      ToastStore.success("'" + this.state.guiltyObject.form_name+"' edited successfully!");
      this.getSubmittedFormsByLicense();
      this.setActiveTabIndex(2);
    })
    .catch((err)=>{
      ToastStore.error("Form submission failed!");
      console.log("error: ", err);
    })


    //Add API here
  }

  sendEmail(params){
    let form = params.form;
    form.send_to_emails.map((auto_email, i)=>{
      let name =  params.submitted_by.data[0].first_name + " " + params.submitted_by.data[0].last_name;
      let emailParams = {
        file: params.pdf,
        token: params.submitted_by.token_data.token,
        license: params.submitted_by.data[0].User_License,
        auth_username: params.submitted_by.data[0].User_ID,
        from_email: params.submitted_by.data[0].email ? params.submitted_by.data[0].email : "support@archontech.com",
        from_name: name ? name : "support@archontech.com",
        send_to_email: auto_email.auto_email,
        send_to_name: auto_email.auto_email,
        content: '<h1>'+name+' submitted form.</h1>',
        subject: 'Submitted Form'
      }
      if( typeof(emailParams.send_to_email) != "undefined" &&  emailParams.send_to_email){
        EmailService.sharedInstance.send(emailParams).then((response)=>{
        })
        .catch((err)=>{
          //ToastStore.error("Email submission!");
          console.log("error: ", err);
        })
      }
    });
  }

  submitNewForm(json_string, files, pdf) {

    const storedCredentials = this.state.storedCredentials;
    const loginResponse = storedCredentials.loginResponse;
    var formToEditIndex = (this.state.tabActiveIndex  -  (2 + (this.state.guiltyObject != null ? 1 : 0 ))) - 1;
     var params = {
      "license":loginResponse.data[0].User_License,
      "auth_username":loginResponse.data[0].User_ID,
      "token":loginResponse.token_data.token,
      "sub_user_id": loginResponse.data[0].recno,
      "form_id": this.state.formsToEdit[formToEditIndex].recno,
      "json_string": json_string,
      "files": files ? files : [],
      "update_attachments_flag": files ? 1 : 0
    };


    FormsService.sharedInstance.submitCustomForm(params)
    .then((response)=>{
      //send pdf here
      if(response.success == 1){
        ToastStore.success(response.message);
      }

       //check if PDF is passed
      let emailParams = {
        "form":this.state.formsToEdit[formToEditIndex],
        "submitted_by":loginResponse,
        "pdf":pdf
      }
      this.sendEmail(emailParams);

      this.getSubmittedFormsByLicense();
      this.closeFormToEdit(formToEditIndex);
      this.setActiveTabIndex(1);

    })
    .catch((err)=>{
      ToastStore.error("Form submission failed!");
      console.log("error: ", err);
    })


  }

  toggleActiveFilter(filter) {

  }

  sortForms(activeFilter, sort) {
    var newList = [];
      switch(activeFilter) {
        case "fileName":
          newList = _.sortBy(this.state.forms, "form_name");
        break;
        case "client":
          newList = _.sortBy(this.state.forms, "client_name");
        break;
      }

      if(sort == "ascending") {
        newList.reverse();
      }
    return newList;
  }

  addField(identifier) {

    var newNewForm = JSON.parse(JSON.stringify(this.state.newForm));

    switch(identifier) {
      case "daily_occurrence":
        newNewForm.occurrences.push({occurrenceTime: "", occurrenceDetails: ""});
      break;

    }

    this.setState({
      newForm: newNewForm
    })
  }

  //This will be messy. DailyActivity is hardcoded.
  renderInputs(formToEdit) {
    var fields = [];
    var newNewForm = JSON.parse(JSON.stringify(this.state.newForm));
    var guiltyObject = formToEdit;
    var formName = guiltyObject.form_name
    if(formName.indexOf("Daily Activity") >= 0) {
      formName = "Daily Activity";
    }

    switch(formName) {
      case "Daily Activity":
          newNewForm.occurrences.map((occurrence, i)=>{
            fields.push(<div key={i}>
                            <Row key={"itemNameLabel"} style={{paddingLeft: 20, paddingRight: 20, paddingBottom: 10}}>
                                <Col inline="true">
                                  <div style={{textAlign: 'left'}}>
                                      Date & Time
                                    <Glyphicon glyph="remove" style={{marginLeft: 10, cursor: "pointer"}}
                                      onClick={()=>{
                                        newNewForm.occurrences.splice(i, 1);
                                        this.setState({newForm: newNewForm})
                                      }}/>
                                  </div>
                                </Col>
                            </Row>
                            <Row key={"eventDateTime"} style={{paddingRight: 20, paddingLeft: 20}}>
                                  <Col inline="true">
                                    <Datetime
                                    style={{}}
                                    onChange={(e)=>{
                                      newNewForm.occurrences[i]["occurrenceDate"] = e;
                                      this.setState({newForm: newNewForm});}}/>
                                </Col>
                              </Row>
                              <br />
                            <FormGroup controlId="detailTextArea" className="row-md-12 " style={{textAlign: "left"}}>
                              <ControlLabel htmlFor="detailTextArea" className="control-label">Detail of Occurence</ControlLabel>
                              <FormControl  componentClass="textarea" placeholder="Detail of Occurence"
                                            style={{width: "100%"}}
                                            value={newNewForm.occurrences[i] ? newNewForm.occurrences[i]["occurenceDetail"] : ""}
                                            onChange={(e)=>{var newNewForm = JSON.parse(JSON.stringify(this.state.newForm));
                                            newNewForm.occurrences[i]["occurenceDetail"] = e.target.value;
                                            this.setState({newForm: newNewForm});}} />
                            </FormGroup>
              </div>);
          });

          fields.push(<Row key={"Add Occurrence button"} style={{marginBottom: 30}}>
                        <Button className="comm-log-btn green-btn col-md-offset-7"
                          onClick={()=>{this.addField("daily_occurrence")}}>Add Occurence</Button>
                      </Row>)
      break

      default:
        fields.push(  <div key={"No Fields"} style={{paddingTop: 80, fontSize: 18}}>Input fields for {guiltyObject.form_name} still under construction ¯\_(ツ)_/¯</div>)
      break
    }

    return fields
  }

  getFormDataByType(dropDownName){ //index used in then() block
    var type = dropDownName.replace(" ", "_");

    const storedCredentials = this.state.storedCredentials;
    const loginResponse = storedCredentials.loginResponse;

       var params = {
        "license":loginResponse.data[0].User_License,
        "auth_username":loginResponse.data[0].User_ID,
        "token":loginResponse.token_data.token,
        "type":type
      };


      FormdataService.sharedInstance.getFormDataByType(params)
        .then((response)=>{
          if(type == "Branch"){
              this.setState({
                branches: this.repackForChoices(response, type)
              });
          }
          if(type == "Client"){
              this.setState({
                clients: this.repackForChoices(response, "client")
              });
          }
          if(type == "Facility"){
              this.setState({
                facilities: this.repackForChoices(response, type)
              });
          }
        })
        .catch((error)=>{
          console.log("getFormDataByType error: ", error);
        });
}

  repackForChoices(items, type) {

    var newItems = [];
    switch(type) {
      case "client":
        items.map((item)=>{
          if(item.is_active === "1") {
              newItems.push({id: item.id, name: item.client_name});
          }
        });
      break;
    }

    return newItems;
  }

  getMySubmittedForms() {

    const storedCredentials = this.state.storedCredentials;
    const loginResponse = storedCredentials.loginResponse;

     var params = {
      "license":loginResponse.data[0].User_License,
      "auth_username":loginResponse.data[0].User_ID,
      "token":loginResponse.token_data.token,
      "sub_user_id": loginResponse.data[0].recno,

    };
    FormsService.sharedInstance.getSubmittedCustomForms(params)
    .then((response)=>{
      this.setState({
        formArchives: response,
      })
    })
    .catch((err)=>{
      console.log("error: ", err);
    })
  }

  getSubmittedFormsByLicense() {

    const storedCredentials = this.state.storedCredentials;
    const loginResponse = storedCredentials.loginResponse;

     var params = {
      "license":loginResponse.data[0].User_License,
      "auth_username":loginResponse.data[0].User_ID,
      "token":loginResponse.token_data.token,
    };
    FormsService.sharedInstance.getSubmittedCustomFormByLicense(params)
    .then((response)=>{
      this.setState({
        formArchives: response,
      })
    })
    .catch((err)=>{
      console.log("error: ", err);
    })
  }

  closeFormToEdit(index) {
    var newFormsToEdit = this.state.formsToEdit.slice();
    newFormsToEdit.splice(index, 1);
    this.setState({
      formsToEdit: newFormsToEdit,
    });
    var newActiveTabIndex = (this.state.guiltyObject == null && newFormsToEdit.length == 0)
                                  ? 2
                                  :  this.state.tabActiveIndex - 1;

      this.setActiveTabIndex(newActiveTabIndex);
    }

  setActiveTabIndex(newTabIndex) {
    var newState = {tabActiveIndex: newTabIndex};
    this.setState(newState);
  }

  createPDFForForm(form) {


    var pdfFieldArray = this.processPDFFormFields(form);
    // var formDocument = <Document>
    //                       <Page size="A4" style={{ backgroundColor: 'white', flexDirection: 'row'}}>
    //                         <View>
    //                         {
    //                           pdfFieldArray
    //                         }
    //                         </View>
    //                       </Page>
    //                     </Document>;

    //return formDocument;

  }

  processPDFFormFields(form) {
    var pdfFieldArray = [];
    //A4 size? width: 612.00, height: 792.00
    // form.map((element, i)=>{
    //   var elementType = element.type;
    //   var parentElementId = element.parentElement != null ? element.parentElement.id : "";
    //   var textFieldTypes = ["text", "textArea", "textInput", "dateField"];
    //   if(textFieldTypes.indexOf(elementType) >= 0) {
    //     elementType = "text";
    //   }
    //
    //   switch(elementType) {
    //     case "text":
    //
    //       console.log("element: ", element);
    //       console.log("element.parentElement != null: ", element.parentElement != null);
    //       //<Text>{element.label != null ? element.label : "No Label"}: {element.text ? element.text : element.value}</Text>
    //       pdfFieldArray.push(<View key={element.type + "_"+ parentElementId +"_"+i} className="row">
    //
    //                           <Text  style={{color: element.fontColor ? element.fontColor : "#000000",
    //                               fontSize: element.fontSize ? element.fontSize : 15,
    //                               width: element.width
    //                                         ? parseFloat(element.width.value) * 595
    //                                         : 595}}>
    //                             {element.label ? element.label + ":" : ""} {element.text ? element.text : element.value}
    //                           </Text>
    //                           </View>
    //                         );
    //     break;
    //     case "column":
    //     console.log("entered column");
    //       pdfFieldArray.push(<View key={element.type + "_"+ parentElementId +"_"+i} style={{ color: 'white', textAlign: 'center' }}>
    //                           <Text> Column</Text>
    //                           {
    //                             this.processPDFFormFields(element.children)
    //                           }
    //                         </View>);
    //     break;
    //     default:
    //     break;
    //   }
    // });

    return pdfFieldArray;
  }

  findClientToDisplay(list) {
    var isFound = false;
    var clientToDisplay = "No Client Set";
    var index = 0;

    //Loop through first heirarchy level
    while (index < list.length && !isFound) {
      if(!isFound && list[index].type === "select" && list[index].buttonType.value === "Client") {
        clientToDisplay = list[index].value;
        isFound = true;
        break;
      }
      index++;
    }

    index = 0;

    //Loop through ALL their children
    if(!isFound) {
      while (index < list.length && !isFound) {
        if(!isFound && list[index].children != null && list[index].children.length > 0) {
          clientToDisplay = this.findClientToDisplay(list[index].children);
          if(clientToDisplay !== "No Client Set") {
            isFound = true;
            break;
          }

        }
        index++;
      }
    }
    return clientToDisplay;
  }

  getNameForRecno(recno, type, list) {
    var rawPressedDropDown;
    var dropDownWithRecno;
    var specialTypes = ["Facility", "Facility Location", "Event"];
    var nameProperty = "name";//because there's Value, facility_name, branch_name :'(
    var recnoProperty = "id";//because there's recno, facility_id, branch_id :'(

    switch(type) {
      case "Facility":
        nameProperty = "facility_name";
        recnoProperty = "facility_id";
    }



    dropDownWithRecno = _.find(list, (rawDropDown)=>{
        return rawDropDown[recnoProperty] == recno;
    });

    if(dropDownWithRecno == null) {
      dropDownWithRecno = {Value: recno + " not found"};
    }
    return dropDownWithRecno[nameProperty];
  }

}

export default Forms;
